module.exports = __webpack_public_path__ + "media/images/nisiginzacc_bg-37a06ce30766cf7f4e59a7800afba4c3.png";